export enum LiPeopleScrapeStatus {
	DRAFT = "DRAFT",
	IN_PROGRESS = "IN_PROGRESS",
	DONE = "DONE",
}

export enum LiPeopleResultScrapeStatus {
	DRAFT = "DRAFT",
	RETRY_PUBLIC_PROFILE = "RETRY_PUBLIC_PROFILE",
	RETRY_COMPANY_PROFILE = "RETRY_COMPANY_PROFILE",
	PUBLIC_PROFILE = "PUBLIC_PROFILE",
	COMPANY_PROFILE = "COMPANY_PROFILE",
	INVALID = "INVALID",
	TRIGGERED = "TRIGGERED",
	IN_PROGRESS = "IN_PROGRESS",
	SCRAPED = "SCRAPED",
	ERROR = "ERROR",
	WAITING = "WAITING",
	APOLLO_ENRICHED = "APOLLO_ENRICHED",
	APOLLO_PERSON_ENRICHED = "APOLLO_PERSON_ENRICHED",
	DONE = "DONE",
	PERSON_FINDING = "PERSON_FINDING",
}

export enum LiPeopleType {
	SEARCH = "SEARCH",
	SPECIFIC = "SPECIFIC",
	MANUAL = "MANUAL",
}
